<script setup lang="ts">
import BackgroundBlurFilter from "@/components/Background/BackgroundBlurFilter.vue";
import BackgroundParallax from "@/components/Background/BackgroundParallax.vue";
import store from "@/store";
</script>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
    data() {
        return {
            backgroundParallaxImages: [
                {
                    image: '100',
                    depth: 0.15,
                    opacity: 1,
                    blur: false,
                    dynamicBlur: 7,
                },
                {
                    image: '101',
                    depth: 0.3,
                    opacity: 0.3,
                    blur: true,
                    dynamicBlur: 13,
                },
                {
                    image: '201',
                    depth: 0.8,
                    opacity: 0.15,
                    blur: false,
                    dynamicBlur: false,
                },
            ],
        }
    },

    props: {
        withBlur: {
            type: Boolean,
            required: false,
            default: true,
        }
    }
})
</script>

<template>
    <template v-if="store.state.pageSize.width > store.state.mobileVersionThresholdWidth">
        <BackgroundParallax :images="backgroundParallaxImages"/>
        <BackgroundBlurFilter v-if="withBlur"/>
    </template>

    <template v-else>
        <div class="background"/>
    </template>
</template>

<style scoped lang="scss">
.background {
    background-image: v-bind('`url("/img/page/landing/bg/100.webp")`');
    background-size: cover;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
</style>
